import React, { useState } from 'react';
import { validateInviteCode, saveInviteCode } from '../config/inviteCodes';
import { features } from '../config/features';
import { registerDevice, isDeviceRegisteredLocally } from '../services/quota';

interface InviteGateProps {
  onSuccess: () => void;
}

/**
 * 邀请码门禁组件
 * 用户需要输入正确的邀请码才能访问应用
 */
export function InviteGate({ onSuccess }: InviteGateProps) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // 通过后端 API 验证邀请码
    const result = await validateInviteCode(code);
    if (!result.valid) {
      setError(result.error || '邀请码无效，请检查后重试');
      setLoading(false);
      return;
    }

    // 检查设备配额（如果启用）
    if (features.deviceQuota > 0) {
      // 先检查本地是否已注册
      if (!isDeviceRegisteredLocally()) {
        const quotaResult = await registerDevice();
        if (!quotaResult.success) {
          setError(quotaResult.error || '名额已满，请联系开发者');
          setLoading(false);
          return;
        }
      }
    }

    // 保存邀请码并进入
    saveInviteCode(code);
    onSuccess();
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary)',
      padding: '20px',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '360px',
      }}>
        {/* Logo */}
        <div style={{
          textAlign: 'center',
          marginBottom: '40px',
        }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: 800,
            letterSpacing: '-1px',
            margin: 0,
            color: 'var(--text-primary)',
          }}>
            enPASS
          </h1>
          <p style={{
            fontSize: '14px',
            color: 'var(--text-muted)',
            marginTop: '8px',
          }}>
            IELTS 学习助手
          </p>
        </div>

        {/* 邀请码表单 */}
        <div className="card">
          <div className="card-body" style={{ padding: '24px' }}>
            <h2 style={{
              fontSize: '16px',
              fontWeight: 700,
              marginBottom: '16px',
              textAlign: 'center',
            }}>
              内测访问
            </h2>
            
            <p style={{
              fontSize: '13px',
              color: 'var(--text-secondary)',
              marginBottom: '20px',
              textAlign: 'center',
              lineHeight: 1.5,
            }}>
              此版本仅限内测用户使用<br />
              请输入邀请码继续
            </p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="输入邀请码"
                autoFocus
                autoComplete="off"
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  fontSize: '16px',
                  border: '2px solid var(--border-color)',
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  boxSizing: 'border-box',
                  marginBottom: '12px',
                }}
              />

              {error && (
                <div style={{
                  padding: '10px 12px',
                  background: 'var(--accent-red)',
                  color: '#000',
                  fontSize: '13px',
                  marginBottom: '12px',
                  textAlign: 'center',
                }}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={!code.trim() || loading}
                className="btn btn-primary"
                style={{
                  width: '100%',
                  padding: '14px',
                  fontSize: '14px',
                }}
              >
                {loading ? '验证中...' : '进入'}
              </button>
            </form>
          </div>
        </div>

        {/* 底部说明 */}
        <p style={{
          fontSize: '12px',
          color: 'var(--text-muted)',
          textAlign: 'center',
          marginTop: '24px',
        }}>
          没有邀请码？请联系开发者获取
        </p>
      </div>
    </div>
  );
}
